var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCompanyPrimary({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7173_28782)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 1.00098C7 0.448692 7.44772 0.000976562 8 0.000976562H16C16.5523 0.000976562 17 0.448692 17 1.00098V4.00098H23C23.5523 4.00098 24 4.44869 24 5.00098V15.001C24 15.5533 23.5523 16.001 23 16.001H16V17.001C16 17.5533 15.5523 18.001 15 18.001H9C8.44772 18.001 8 17.5533 8 17.001V16.001H1C0.447715 16.001 0 15.5533 0 15.001V5.00098C0 4.44869 0.447715 4.00098 1 4.00098H7V1.00098ZM2 6.00098V14.001H8V13.001C8 12.4487 8.44772 12.001 9 12.001H15C15.5523 12.001 16 12.4487 16 13.001V14.001H22V6.00098H2ZM15 4.00098H9V2.00098H15V4.00098ZM14 14.001H10V16.001H14V15.0024C14 15.0019 14 15.0014 14 15.001C14 15.0005 14 15 14 14.9996V14.001ZM2 17.001C2.55228 17.001 3 17.4487 3 18.001V22.001H21V18.001C21 17.4487 21.4477 17.001 22 17.001C22.5523 17.001 23 17.4487 23 18.001V23.001C23 23.5533 22.5523 24.001 22 24.001H2C1.44772 24.001 1 23.5533 1 23.001V18.001C1 17.4487 1.44772 17.001 2 17.001Z",
    fill: "#55489E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7173_28782"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompanyPrimary);
export default __webpack_public_path__ + "static/media/company-primary.a313584d.svg";
export { ForwardRef as ReactComponent };